export default "__VITE_PUBLIC_ASSET__8094a236__"